const config = {


  // API_URL: "https://api.staging.clientsspace.com/v1", //process.env.REACT_APP_API_URL,
  // DASHBOARD_API_URL: "https://staging.dueplex.com/api", //process.env.REACT_APP_API_URL,
  // DASHBOARD_URL: "https://staging.dueplex.com",


  //  API_URL: "https://api.sandbox.clientsspace.com/v1", //process.env.REACT_APP_API_URL,
  //  DASHBOARD_API_URL: "https://sandbox.dueplex.com/api", //process.env.REACT_APP_API_URL,
  //  DASHBOARD_URL: "https://sandbox.dueplex.com",

  API_URL: "https://api.clientsspace.com/v1", //process.env.REACT_APP_API_URL,
  DASHBOARD_API_URL: "https://app.dueplex.com/api", //process.env.REACT_APP_API_URL,
  DASHBOARD_URL: "https://app.dueplex.com",
  
  APP_IMAGE_URI: "https://cdn.dueplex.com/files/",
  APP_FILE_URI: "https://cdn.dueplex.com/attachments/",

};

export default config;
